import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { SKIP_ACCEPT_LANGUAGE } from '../http-context';

export const apiAcceptLanguageInterceptor: HttpInterceptorFn = (request, next) => {
    if (request.context.get(SKIP_ACCEPT_LANGUAGE)) {
        return next(request);
    }

    const translateService = inject(TranslateService);

    return next(
        request.clone({
            headers: request.headers.set('Accept-Language', translateService.currentLang),
        }),
    );
};
